import React from 'react';
import { Button } from '@mui/joy';
import { addToCalendar } from '../../utils/calendarUtils';

interface MeetingData {
  id: string;
  scheduledAt: string;
  duration: number;
  location: string;
  notes?: string;
  employer: {
    companyName: string;
  };
}

interface AddToCalendarButtonProps {
  variant: 'google' | 'apple' | 'microsoft';
  meetingData: MeetingData;
  applicantNote?: string;
}

const AddToCalendarButton: React.FC<AddToCalendarButtonProps> = ({ 
  variant, 
  meetingData, 
  applicantNote 
}) => {
  const getButtonText = () => {
    switch (variant) {
      case 'google':
        return 'Google Calendar';
      case 'apple':
        return 'Apple Calendar';
      case 'microsoft':
        return 'Microsoft Outlook';
      default:
        return 'Add to Calendar';
    }
  };

  const handleClick = () => {
    addToCalendar(variant, meetingData, applicantNote);
  };

  return (
    <Button
      variant="soft"
      onClick={handleClick}
      sx={{
        backgroundColor: '#E5E7EB',
        color: '#2e2d7e',
        '&:hover': {
          backgroundColor: '#D1D5DB'
        }
      }}
    >
      {getButtonText()}
    </Button>
  );
};

export default AddToCalendarButton; 